import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

const StyledToggleSwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 37px;
  height: 20px;
`;

const StyledToggleSwitchSlider = styled.span<{ disabled?: boolean }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${theme.colors.white};
  border: ${(prop) =>
    prop.disabled
      ? `1px solid ${theme.colors.grey_4}`
      : `1px solid ${theme.colors.purple}`};
  border-radius: 35px;
  transition: 0.2s;

  &:before {
    position: absolute;
    content: "";
    width: 15px;
    height: 15px;
    top: 50%;
    left: 6%;
    background-color: ${(prop) =>
      prop.disabled ? `${theme.colors.grey_4}` : `${theme.colors.purple}`};
    border-radius: 100%;
    transition: 0.2s;
    transform: translateY(-50%);
  }
`;

const StyledToggleSwitchInput = styled.input<{ disabled?: boolean }>`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${StyledToggleSwitchSlider} {
    background-color: ${(prop) =>
      prop.disabled ? `${theme.colors.grey_4}` : `${theme.colors.purple}`};
  }

  &:checked + ${StyledToggleSwitchSlider}:before {
    transform: translate(16px, -50%);
    background-color: ${theme.colors.white};
    box-sizing: border-box;
  }
`;

export {
  StyledToggleSwitchContainer,
  StyledToggleSwitchInput,
  StyledToggleSwitchSlider,
};
